export default __webpack_public_path__ + "static/media/flag.629a6f2e.png";